import { render, staticRenderFns } from "./selectItem.vue?vue&type=template&id=67d16f54&"
import script from "./selectItem.vue?vue&type=script&lang=js&"
export * from "./selectItem.vue?vue&type=script&lang=js&"
import style0 from "./selectItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../mercari_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports